import React, { Component } from 'react';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import __ from 'lodash';
import { Form,Button, Row, Col, Alert} from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';
import history from '../../../../history';
import LearningContentReq from '../../../../entity/LearningContentReq';
import ReactPlayer from 'react-player';


class VideoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching: false,
            isLoading: false,
            alertShow: false,            
            resMessage: '',
            data: props.location.state,
            action: 'add',
            idVideo: null,
            linkVideo: null,
            judulLearning: ''
        };
    }   

    async componentDidMount() {             
        this.setState({ isFetching: true });
        
        //console.log(this.props.location.state) 
        if(this.props.location.state.idProfil !== null) {
            this.getKontenVideo(this.props.location.state.idProfil );
            this.setState({ judulLearning: this.props.location.state.judul })
            this.setState({action: 'edit'})
        }       
        
        this.setState({ isFetching: false });
    }

    async getKontenVideo(id) {
        this.setState({ isFetching: true });
        const result = await accountManagement.get(CONFIG.LEARNING_GET_VIDEO_PROFIL + id)
            .catch(function(error){console.log(error)});        
        if (result) {            
            this.setState({ idVideo: result.data.data.idVideo, linkVideo: result.data.data.linkVideo});
            this.setState({ isFetching: false });
        }   
    }

    handleSubmit = async(e) => {               
        e.preventDefault();
        if( !window.confirm('Konfirmasi Simpan ?')) {
            return false;
        }
        this.setState({isFetching: true});
        let { data, action} = this.state;
        if(data.owner === 'PRIME') { action = 'add'; }

        if(action === 'add') {
            const response = await accountManagement.post(CONFIG.LEARNING_POST_PEMB_LATIHAN, {...LearningContentReq,
                ["idKelas"]: data.idKelas,
                ["idMapel"]: data.idMapel,
                ["idBab"]: data.idBab,
                ["idSubBab"]: data.idSubBab,
                ["idTematik"]: data.idTematik,
                ["idSubTematik"]: data.idSubTematik,
                ["idPembTematik"]: data.idPembTematik,
                ["idRencana"]: data.idRencana,
                ["tipeKontent"]: 'VIDEO',
                ["idVideo"]: this.state.idVideo,
                ["linkVideo"]: this.state.linkVideo,
                ["judul"]: this.state.judulLearning,
                ["owner"]: 'GURU'
            }).catch(function(error){ console.log(error) });        
            
            if(response) {
                if(response.data.code === '200'){
                    history.push({
                        pathname: '/learning_konten/VIDEO/',
                        state: this.state.data
                    })                              
                } else {
                    this.setState({
                        alertShow: true,
                        resMessage: response.data.msg
                    })                
                }
                this.setState({isFetching: false});            
            }
        } 
        else if(action === 'edit') {
            const response = await accountManagement.post(CONFIG.LEARNING_POST_EDIT_PEMB_LATIHAN, {LearningContentReq,
                ["idProfilePemLat"]: data.idProfil,                
                ["tipeKontent"]: 'VIDEO',
                ["idVideo"]: this.state.idVideo,
                ["linkVideo"]: this.state.linkVideo,
                ["judul"]: this.state.judulLearning                
            }).catch(function(error){ console.log(error) });        
            
            if(response) {                
                if(response.data.code === '200'){
                    history.push({
                        pathname: '/learning_konten/VIDEO/',
                        state: this.state.data
                    })                              
                } else {
                    this.setState({
                        alertShow: true,
                        resMessage: response.data.msg
                    })                
                }
                this.setState({isFetching: false});            
            }
        }
        
    }

    handleInput = (evt) => {
        const value = evt.target.value;
        this.setState({ judulLearning: value });
    }

    handleChange = (e) => {
        let value = e.target.value;
        if(value !== '') {
            this.setState({linkVideo: value})
        }
    }

    handleBack = () => {
        history.push({
            pathname: '/learning_konten/VIDEO/',
            state: this.state.data
        })
    }

    render() {
        return (
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <LoaderModal isFetching={this.state.isFetching} />
                <Row>
                    <Col>
                    <h3>Learning Video: {this.state.action}</h3>  
                    </Col>                    
                    <Col>
                        <Button variant="outline-danger pull-right" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.handleBack() }}>
                            Keluar <i className="fa fa-arrow-right"></i></Button>                                     
                    </Col>
                </Row>

                {this.loadAlert()}
                <div>
                <Form onSubmit={this.handleSubmit}>
                    <Row style={{ marginTop: '20px' }}>
                        <Col sm={6}>
                            <input type="text" className="form-control" maxLength="100" placeholder="Input Judul Learning..." required
                                onChange={this.handleInput} value={this.state.judulLearning}/>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: '20px' }}>
                        <Col>
                            <Form.Group controlId="url">
                                <Form.Label>URL Video :</Form.Label>   
                                <input type="url" className="form-control" defaultValue={this.state.linkVideo === null ? "" : this.state.linkVideo}
                                    maxLength="200" onChange={this.handleChange} required/>
                            </Form.Group>  
                        </Col>
                    </Row>

                    <Row style={{ marginTop: '20px' }}>
                        <Col>
                            <Button type="submit" variant="outline-primary pull-right" >
                                Simpan <i className="fa fa-floppy-o"></i></Button> 
                        </Col>
                    </Row>
                </Form>

                <Row style={{ marginTop: '20px' }}>
                    <Col>   
                        <label>Preview: </label>                                     
                        <ReactPlayer 
                            url={this.state.linkVideo} 
                            controls
                        />
                    </Col>
                </Row>

                
                </div>
                
                
                
                
                
            </div>
        );
    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    } 
}

export default VideoForm;